import {reactive} from 'vue'

export { default as FormError } from './FormError.vue';
export const initErrorBag = () => {
    return reactive({
        message: '错误',
        errors: [] as Array<string>,
    });
}